import { lazy } from 'react';

const AdminFormVehiclesManagement = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesManagements/FormManagement/FormVehiclesManagement').then(module => ({
    default: module.AdminFormVehiclesManagement,
  }))
);

const AdminVehiclesManagements = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesManagements/MainScreen/VehicleManagements').then(module => ({
    default: module.AdminVehiclesManagements,
  }))
);

const LeasesContracts = lazy(() =>
  import('components/Administrator/Leases/LeasesContracts/index').then(module => ({
    default: module.LeasesContracts,
  }))
);

const AdminLeasesApplies = lazy(() =>
  import('components/Administrator/Leases/LeasesApplies/index').then(module => ({
    default: module.AdminLeasesApplies,
  }))
);

const LeasesPayments = lazy(() =>
  import('components/Administrator/Leases/LeasesPayments/index').then(module => ({
    default: module.LeasesPayments,
  }))
);

const LeasesManagements = lazy(() =>
  import('components/Administrator/Leases/LeasesManagements/MainScreen/index').then(module => ({
    default: module.LeasesManagements,
  }))
);

const FormManagement = lazy(() =>
  import('components/Administrator/Leases/LeasesManagements/FormManagement/index').then(module => ({
    default: module.FormManagement,
  }))
);

const AdminVehiclesApplies = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesApplies/VehiclesApplies').then(module => ({
    default: module.AdminVehiclesApplies,
  }))
);

const AdminVehiclesPayments = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesPayments/AdminVehiclesPayments').then(module => ({
    default: module.AdminVehiclesPayments,
  }))
);

const AdminVehiclesCredits = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesCredits/VehiclesCredits').then(module => ({
    default: module.AdminVehiclesCredits,
  }))
);

const AdminUncollectibleCredits = lazy(() =>
  import('components/Administrator/Vehicles/VehicleUncollectibleCredits/VehicleUncollectibleCredits').then(module => ({
    default: module.AdminUncollectibleCredits,
  }))
);

const AdminVehiclesSales = lazy(() =>
  import('components/Administrator/Vehicles/VehiclesSales/AdminVehiclesSales').then(module => ({
    default: module.AdminVehiclesSales,
  }))
);

const AdminCredits = lazy(() =>
  import('components/Administrator/Credits/Credits/AdminCredits').then(module => ({
    default: module.AdminCredits,
  }))
);

const AdminCreditsApplies = lazy(() =>
  import('components/Administrator/Credits/CreditsApplies/AdminCreditsApplies').then(module => ({
    default: module.AdminCreditsApplies,
  }))
);

const AdminFormCreditsManagement = lazy(() =>
  import('components/Administrator/Credits/CreditsManagments/FormManagement/AdminFormCreditsManagement').then(module => ({
    default: module.AdminFormCreditsManagement,
  }))
);

const AdminCreditsManagements = lazy(() =>
  import('components/Administrator/Credits/CreditsManagments/MainScreen/AdminCreditsManagements').then(module => ({
    default: module.AdminCreditsManagements,
  }))
);

const AdminCreditsUncollectible = lazy(() =>
  import('components/Administrator/Credits/UncollectibleCredits/AdminUncollectibleCredits').then(module => ({
    default: module.AdminCreditsUncollectible,
  }))
);

const AdminCreditsPayments = lazy(() =>
  import('components/Administrator/Credits/CreditsPayments/AdminCreditsPayments').then(module => ({
    default: module.AdminCreditsPayments,
  }))
);

const AdminCreditsCollateral = lazy(() =>
  import('components/Administrator/Credits/CreditsCollateral/AdminCreditsCollateral').then(module => ({
    default: module.AdminCreditsCollateral,
  }))
);

const PaymentReception = lazy(() =>
  import('components/Administrator/JudicialPremises/PaymentReception/index').then(module => ({
    default: module.PaymentReception,
  }))
);

const PremisesManagements = lazy(() =>
  import('components/Administrator/JudicialPremises/PremisesManagements/index').then(module => ({
    default: module.PremisesManagements,
  }))
);

const AdminPaymentLaywer = lazy(() =>
  import('components/Administrator/Lawyer/AdminPaymentLaywer/index').then(module => ({
    default: module.AdminPaymentLaywer,
  }))
);

const AdminLawyerManagements = lazy(() =>
  import('components/Administrator/Lawyer/AdminLawyerManagements/index').then(module => ({
    default: module.AdminLawyerManagements,
  }))
);

const CashierManagement = lazy(() =>
  import('components/Administrator/Cashier/CashierManagement/MainScreen/index').then(module => ({
    default: module.CashierManagement,
  }))
);

const CashierManagementForm = lazy(() =>
  import('components/Administrator/Cashier/CashierManagement/ManagementForm/index').then(module => ({
    default: module.CashierManagementForm,
  }))
);

const routesAdministrator = [
  {
    path: null,
    name: "Arrendamientos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['129_ARRENDAMIENTOS'], //TODO: CAMBIAR
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador/arrendamientos/contratos",
        name: "Contratos",
        icon: "nc-icon nc-paper",
        component: <LeasesContracts />,
        permissions: ['130_ARRENDAMIENTOS_CONTRATOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/arrendamientos/solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <AdminLeasesApplies />,
        permissions: ['131_ARRENDAMIENTOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/arrendamientos/boletas-bancarias",
        name: "Boletas Bancarias",
        icon: "nc-icon nc-paper",
        component: <LeasesPayments />,
        permissions: ['132_ARRENDAMIENTOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/arrendamientos/gestiones",
        name: "Otras gestiones",
        icon: "nc-icon nc-paper",
        component: <LeasesManagements />,
        permissions: ['133_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-arrendamientos-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormManagement />,
        permissions: ['133_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Vehículos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['134_VEHICULOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador-vehiculos-ventas",
        name: "Ventas",
        icon: "nc-icon nc-paper",
        component: <AdminVehiclesSales />,
        permissions: ['136_VEHICULOS_VENTAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <AdminVehiclesCredits />,
        permissions: ['135_VEHICULOS_CONTRATOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <AdminVehiclesApplies />,
        permissions: ['137_VEHICULOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-pagos",
        name: "Pagos Creditos Vehículos",
        icon: "nc-icon nc-paper",
        component: <AdminVehiclesPayments />,
        permissions: ['138_VEHICULOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminVehiclesManagements />,
        permissions: ['139_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormVehiclesManagement />,
        permissions: ['139_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormVehiclesManagement />,
        permissions: ['139_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormVehiclesManagement />,
        permissions: ['139_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-vehiculos-creditos-incobrables",
        name: "Creditos Incobrables",
        icon: "nc-icon nc-paper",
        component: <AdminUncollectibleCredits />,
        permissions: ['209_VEHICULOS_CREDITOS_INCOBRABLES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Creditos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['140_CREDITOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador-creditos-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <AdminCredits />,
        permissions: ['237_CREDITOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <AdminCreditsApplies />,
        permissions: ['142_CREDITOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-pagos",
        name: "Pagos Créditos",
        icon: "nc-icon nc-paper",
        component: <AdminCreditsPayments />,
        permissions: ['143_CREDITOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminCreditsManagements />,
        permissions: ['144_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-gestiones-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormCreditsManagement />,
        permissions: ['144_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-gestiones-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormCreditsManagement />,
        permissions: ['144_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-gestiones-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminFormCreditsManagement />,
        permissions: ['144_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador-creditos-garantias",
        name: "Garantias",
        icon: "nc-icon nc-paper",
        component: <AdminCreditsCollateral />,
        permissions: ['240_CREDITOS_GARANTIAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-incobrables",
        name: "Creditos Incobrables",
        icon: "nc-icon nc-paper",
        component: <AdminCreditsUncollectible />,
        permissions: ['238_CREDITOS_INCOBRABLES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Abogacía & Notariado",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['226_ABOGACÍA_&_NOTARIADO'], //TODO: CAMBIAR PERMISOS
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador/abogacia-y-notariado/boletas-bancarias",
        name: "Boletas Bancarias",
        icon: "nc-icon nc-paper",
        component: <AdminPaymentLaywer />,
        permissions: ['227_BOLETAS_BANCARIAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/abogacia-y-notariado/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <AdminLawyerManagements />,
        permissions: ['233_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Predio Judicial",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['224_PREDIO_JUDICIAL'], //TODO: CAMBIAR PERMISOS
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador/predio-judicial/boletas-bancarias",
        name: "Boletas Bancarias",
        icon: "nc-icon nc-paper",
        component: <PaymentReception />,
        permissions: ['225_BOLETAS_BANCARIAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/predio-judicial/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <PremisesManagements />,
        permissions: ['231_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Cajas",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['246_CAJAS'], //TODO: CAMBIAR PERMISOS
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/administrador/cajas/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <CashierManagement />,
        permissions: ['247_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/administrador/cajas/gestiones/formulario",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <CashierManagementForm />,
        permissions: ['247_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/administrador/cajas/gestiones/formulario/:idgestion",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <CashierManagementForm />,
        permissions: ['247_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
    ],
  }
];

export {
  routesAdministrator
}